import { taskAPI } from './task'

export const getAuthorization = async () => {
    const res = await taskAPI.get('/tc/authorize').then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getTokenFromCallback = async (code, state) => {
    const res = await taskAPI.get(`/tc/callback?code=${code}&state=${state}`).then((rs) => (rs.ok ? rs.data : rs.ok))
    return res
}

export const getProjects = async () => {
    const res = await taskAPI.get('/tc/projects').then((rs) => (rs.ok ? rs.data : rs))
    return res
}

export const getFeaturesFromProject = async (projectId) => {
    const res = await taskAPI.get(`/tc/projects/${projectId}`).then((rs) => (rs.ok ? rs.data : rs))
    return res
}
